import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import ViewReservation from '../../../components/siteadmin/ViewReservation';
import Loader from '../../../components/Loader';
import NotFound from '../../notFound/NotFound';
import { viewReservationAdmin } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';
import s from './ViewRefund.css';

const ViewRefund = ({ data, viewType }) => {

    if (data?.loading) {
        return <Loader type={"text"} />;
    } else if (!data?.viewReservationAdmin) {
        return <NotFound />
    }
    return (
        <ViewReservation data={data?.viewReservationAdmin}
            refetch={data?.refetch}
            viewType={viewType}
        />
    )
};

ViewRefund.propTypes = {
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getAllReservationAdmin: PropTypes.array,
    }),
    viewType: PropTypes.string,
};

export default compose(
    withStyles(s),
    withQuery(viewReservationAdmin,
        {
            options: (props) => ({
                variables: { id: props.id },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }),
)(ViewRefund);
